import { CircularProgress } from "@material-ui/core";
import React, { useContext, useState } from "react";
import { StoreContext } from "../../../../../Store/Provider";

function ShipmentDataDetails(props) {
  const context = useContext(StoreContext);
  const { detail } = props;
  let obj = {};
  Object.entries(props.detail?.data).forEach(([key, value]) => {
    const values =
      typeof value === "string" ? value.replaceAll(",", ", ") : value;
    obj = {
      ...obj,
      [key]: values,
    };
  });
  //   console.log(props, obj);
  if (detail.loading) {
    return (
      <div className="sidebarDataSection container-fluid ShipmentDataDetails">
        <div
          className="loadingContent"
          style={{
            height: "100%",
          }}
        >
          <CircularProgress />
        </div>
      </div>
    );
  }
  return (
    <div className="sidebarDataSection container-fluid ShipmentDataDetails">
      <div className="row">
        <div className="col-sm-6 col-12">
          <span>Type</span>
          <p title={obj.ContainerMode}>
            {obj.ContainerMode ? obj.ContainerMode : "N/A"}
          </p>
        </div>
        <div className="col-sm-6 col-12">
          <span>Carrier</span>
          <p
            title={`${obj.CarrierName} ${
              obj.CarrierName ? `(${obj.CarrierCode})` : ""
            }`}
          >
            {obj.CarrierName ? obj.CarrierName : "N/A"}{" "}
            {obj.CarrierName ? <>({obj.CarrierCode})</> : ""}
          </p>
        </div>
        {obj.TransportMode !== "AIR" && (
          <div className="col-sm-6 col-12">
            <span>Container #</span>
            <p title={obj.ContainerNumbers}>
              {obj.ContainerNumbers ? obj.ContainerNumbers : "N/A"}
            </p>
          </div>
        )}

        <div className="col-sm-6 col-12">
          <span>Volume</span>
          <p title={`${obj.TotalVolume} ${obj.TotalVolumeUQ}`}>
            {obj.TotalVolume
              ? context.calculateAmmount(parseFloat(obj.TotalVolume))
              : "N/A"}{" "}
            {obj.TotalVolumeUQ}
            {/* m<sup>3</sup> */}
          </p>
        </div>
        <div className="col-sm-6 col-12">
          <span>Weight</span>
          <p title={`${obj.TotalWeight} ${obj.TotalWeightUQ}`}>
            {obj.TotalWeight
              ? context.calculateAmmount(parseFloat(obj.TotalWeight))
              : "N/A"}{" "}
            {obj.TotalWeightUQ}
          </p>
        </div>
        <div className="col-sm-6 col-12">
          <span>House BL #</span>
          <p title={obj.HouseBL}>{obj.HouseBL ? obj.HouseBL : "N/A"}</p>
        </div>
        <div className="col-sm-6 col-12">
          <span>Shipper</span>
          <p title={obj.ConsignorName}>
            {obj.ConsignorName ? obj.ConsignorName : "N/A"}
          </p>
        </div>
        <div className="col-sm-6 col-12">
          <span>Consignee</span>
          <p title={obj.ConsigneeName}>
            {obj.ConsigneeName ? obj.ConsigneeName : "N/A"}
          </p>
        </div>
        <div className="col-sm-6 col-12">
          <span>Order Ref</span>
          <p title={obj.OrderRef}>{obj.OrderRef ? obj.OrderRef : "N/A"}</p>
        </div>
        {obj.TransportMode === "SEA" && (
          <div className="col-sm-6 col-12">
            <span>Master BL #</span>
            <p title={obj.MasterBillNumber}>
              {obj.MasterBillNumber ? obj.MasterBillNumber : "N/A"}
            </p>
          </div>
        )}
        {obj.TransportMode === "AIR" && (
          <div className="col-sm-6 col-12">
            <span>Master AWB #</span>
            <p title={obj.MasterBillNumber}>
              {obj.MasterBillNumber ? obj.MasterBillNumber : "N/A"}
            </p>
          </div>
        )}
        {obj.TransportMode === "ROA" ||
        obj.TransportMode === "RAI" ||
        obj.TransportMode === "COU" ? (
          <div className="col-sm-6 col-12">
            <span>BOL #</span>
            <p title={obj.MasterBillNumber}>
              {obj.MasterBillNumber ? obj.MasterBillNumber : "N/A"}
            </p>
          </div>
        ) : null}
        {obj.TransportMode === "SEA" || obj.TransportMode === "COU" ? (
          <div className="col-sm-6 col-12">
            <span>Vessel</span>
            <p title={obj.Vessal}>{obj.Vessal ? obj.Vessal : "N/A"}</p>
          </div>
        ) : null}
        {obj.TransportMode === "ROA" && (
          <div className="col-sm-6 col-12">
            <span>Truck Ref#</span>
            <p title={obj.Voyage}>{obj.Voyage ? obj.Voyage : "N/A"}</p>
          </div>
        )}
        {obj.TransportMode === "RAI" && (
          <div className="col-sm-6 col-12">
            <span>Journey No#</span>
            <p title={obj.Voyage}>{obj.Voyage ? obj.Voyage : "N/A"}</p>
          </div>
        )}
        {obj.TransportMode === "SEA" || obj.TransportMode === "COU" ? (
          <div className="col-sm-6 col-12">
            <span>Voyage</span>
            <p title={obj.Voyage}>{obj.Voyage ? obj.Voyage : "N/A"}</p>
          </div>
        ) : null}
        {obj.TransportMode === "AIR" && (
          <div className="col-sm-6 col-12">
            <span>Flight#</span>
            <p title={obj.Voyage}>{obj.Voyage ? obj.Voyage : "N/A"}</p>
          </div>
        )}
        {obj.TransportMode === "RAI" && (
          <div className="col-sm-6 col-12">
            <span>Journey Ref#</span>
            <p title={obj.Vessal}>{obj.Vessal ? obj.Vessal : "N/A"}</p>
          </div>
        )}
        <div className="col-sm-6 col-12">
          <span>Inco Term</span>
          <p title={obj.INCOTerm}>{obj.INCOTerm ? obj.INCOTerm : "N/A"}</p>
        </div>
        <div className="col-sm-6 col-12">
          <span>Goods Descriptions</span>
          <p title={obj.GoodsDescription}>
            {obj.GoodsDescription ? obj.GoodsDescription : "N/A"}
          </p>
        </div>
      </div>
    </div>
  );
}

export default ShipmentDataDetails;
